import React from "react"
import CustomDropdown from "../../../../../components/common/Dropdown/CustomDropDown"
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent"

const RelatedMaterials = () => {
  const data = [
    { type: "Related Materials", name: "Maelano Go Label", lastUpdated: "29/07/2024", status: "Inactive" },
    { type: "Related Materials", name: "Maelano Go Label", lastUpdated: "29/07/2024", status: "Active" },
    { type: "Related Materials", name: "Maelano Go Label", lastUpdated: "29/07/2024", status: "Inactive" },
    { type: "Related Materials", name: "Maelano Go Label", lastUpdated: "29/07/2024", status: "Inactive" },
    { type: "Related Materials", name: "Maelano Go Label", lastUpdated: "29/07/2024", status: "Inactive" },
    { type: "Related Materials", name: "Maelano Go Label", lastUpdated: "29/07/2024", status: "Active" },
    { type: "Related Materials", name: "Maelano Go Label", lastUpdated: "29/07/2024", status: "Inactive" },
    { type: "Related Materials", name: "Maelano Go Label", lastUpdated: "29/07/2024", status: "Inactive" },
  ]

  const columns = [
    { name: "Document Type", selector: (row) => row.type },
    { name: "Template Name", selector: (row) => row.name },
    { name: "Last Updated", selector: (row) => row.lastUpdated },
    { name: "Status", selector: (row) => row.status },
    { name: "Action", cell: () => <CustomDropdown title={"Action"} /> },
  ]
  return (
    <div className="bg-white p-3 mt-3">
      <DatatableComponent data={data} columns={columns} type={"gray"} pagination />
    </div>
  )
}

export default RelatedMaterials
